module.exports = __webpack_public_path__ + "assets/img/6_6.dc3a30a1.png";